var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: _vm.titulo } },
        [
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.sim_serie_numero_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: _vm.accion_modal == "EDITAR"
                },
                on: {
                  change: function($event) {
                    return _vm.tomar_estado()
                  }
                },
                model: {
                  value: _vm.formFields.sim_serie_numero_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.sim_serie_numero_new, "value", $$v)
                  },
                  expression: "formFields.sim_serie_numero_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.sim_estado_new.label,
                  "prepend-icon": "home_repair_service",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.sim_estado_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.sim_estado_new, "value", $$v)
                  },
                  expression: "formFields.sim_estado_new.value"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }